import styled from 'styled-components'

export const GroupCard = styled.div`
  background: #f6f6f6;
  border-radius: 4px;
  margin: 12px 0 0;
  overflow: hidden;
`

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 42px 14px 33px;
  border-bottom: 1px solid rgba(119, 119, 119, 0.15);
`

export const GroupName = styled.span`
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #3d3d3d;
`

export const OffBadge = styled.span`
  background: #115850;
  color: #fff;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 4px;
`

export const ProgressSection = styled.div`
  padding: 12px 42px 8px 33px;
`

export const ProgressInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const ProgressQtyLabel = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: #777777;
`

export const ProgressHint = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: #115850;
  font-style: italic;
`

export const ProgressBarWrap = styled.div`
  background: #e0e0e0;
  border-radius: 999px;
  height: 8px;
  overflow: hidden;
`

export const ProgressBarFill = styled.div<{ pct: number }>`
  background: #115850;
  border-radius: 999px;
  height: 100%;
  width: ${p => Math.min(p.pct, 100)}%;
  transition: width 0.3s ease;
`

export const Milestones = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
  margin-bottom: 4px;
`

export const MilestoneItem = styled.span<{ reached: boolean }>`
  font-family: 'Lato', sans-serif;
  font-size: 11px;
  font-weight: ${p => (p.reached ? '700' : '400')};
  color: ${p => (p.reached ? '#115850' : '#777777')};
`

export const GroupFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 42px 12px 33px;
  background: rgba(17, 88, 80, 0.06);
  margin-top: 4px;
`

export const FooterSavings = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: #115850;
  font-style: italic;
`
